import type { SubTemplateValueSetupField } from '../../types/templateModel'
import { TemplateFieldsTable } from './TemplateFieldsTable'

type Props = {
  level: number
  field: SubTemplateValueSetupField
  isCollapsible: boolean
}

export const SubTemplateValueSetupTable = ({
  field,
  level,
  isCollapsible,
}: Props) => {
  const templateVariants = field.value?.variants || []

  /**
   * No fields are passed in since multiple sub-template value setup entries don't contain
   * any fields. Instead, the value setup's variants are shown below with an extra level of indentation.
   */
  return (
    <TemplateFieldsTable
      level={level}
      parent={field}
      dynamicFunctions={null}
      declaredFunctions={null}
      isCollapsible={isCollapsible}
    >
      {templateVariants.map((templateVariant) => (
        <TemplateFieldsTable
          key={templateVariant.subTemplateIdentifier}
          level={level + 1}
          parent={templateVariant}
          fields={templateVariant.fields}
          declaredFunctions={templateVariant.declaredFunctions}
          dynamicFunctions={templateVariant.dynamicFunctions}
          isCollapsible={isCollapsible}
        />
      ))}
    </TemplateFieldsTable>
  )
}
